export const DEFAULT_MAX_ERROR_MESSAGE_LENGTH = 200

// Matches the start of a Java exception class name such as
// "java.net.UnknownHostException", which servers often append to a message.
const EXCEPTION_CLASS_PATTERN = /\s+(?:[a-z][\w]*\.)+[A-Z]\w*(?:Exception|Error)\b/

/**
 * Reduces a raw error message from the server to something short enough to show
 * in the UI: keeps the first line, drops any trailing exception class name and
 * stack trace, and truncates what remains.
 */
export const summarizeErrorMessage = (
    message: string | undefined | null,
    maxLength: number = DEFAULT_MAX_ERROR_MESSAGE_LENGTH
): string => {
    if (!message) {
        return ""
    }
    let summary = message.split(/\r?\n/)[0]
    const exceptionMatch = EXCEPTION_CLASS_PATTERN.exec(summary)
    if (exceptionMatch && exceptionMatch.index > 0) {
        summary = summary.slice(0, exceptionMatch.index)
    }
    summary = summary.replace(/\s+/g, " ").trim()
    if (summary.length > maxLength) {
        summary = summary.slice(0, maxLength).trimEnd() + "…"
    }
    return summary
}
